import { render, staticRenderFns } from "./goTop.vue?vue&type=template&id=52413a1d&"
import script from "./goTop.vue?vue&type=script&lang=js&"
export * from "./goTop.vue?vue&type=script&lang=js&"
import style0 from "./goTop.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports